<mat-icon
  [matTooltip]="text"
  [matTooltipPosition]="position">info
</mat-icon>
